/*

   Common files for the PRODUCTION environment.

*/
import firebase from 'firebase/app'
import 'firebase/functions'

// const serverLoc = 'http://localhost:5001/samanthas-art/us-central1/app/'
const serverBase = 'contrib.naloxofind.com'
const serverLoc = 'https://contrib.naloxofind.com/'
const emailDomain = 'naloxofind.com'

var firebaseConfig = {
    apiKey: "AIzaSyBFMObzT8mfqjSTgI5xocmPorF-rnrk_w4",
    authDomain: "naloxofind.firebaseapp.com",
    databaseURL: "https://naloxofind.firebaseio.com",
    projectId: "naloxofind",
    storageBucket: "",
    messagingSenderId: "568595913587"
};

// const mapsAPIkey = "AIzaSyAIDdf82NHO64i78UKsj3-BI0vW3KVHg9k" // For Google Maps NaloxoFind-Test


// const testRecaptchaSiteKey = '6LeE9H8UAAAAAJn1_iYsm4AVbFyZp_Wzt8pb5hlm'

let theFunctions = null
function getFunctions () {
  if (!theFunctions) {
    theFunctions = firebase.functions()
    // theFunctions.useFunctionsEmulator('https://us-central1-naloxofind-test.cloudfunctions.net')
  }
  return theFunctions
}

export default {
  'type' : "prod",
  'serverBase' : serverBase,
  'serverLoc': serverLoc,
  'firebaseConfig': firebaseConfig,
  'getFunctions': getFunctions,
  'emailDomain': emailDomain,
}
